/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import PresiCard from '../../components/PresiCard';
import PresiResume from '../../components/PresiResume/PresiResume';
import useDimension from '../../hooks/useDimension';
import groupBy from 'array.prototype.groupby';
const ListCandidates = ({ 
  currentState,
  currentData,
  JSONState,
  shortVersion,
  showResume = true,
  limit,
  limitLenght,
  showVotes,
  country,
  theme,
  formatNumber }) => {
  /* params */
  const [searchParams] = useSearchParams();
  const paramElecciones = searchParams.get('elecciones');
  const paramsCandidatos = searchParams.get('candidatos');
  const elecciones = paramElecciones === 'false' ? false : true;
  const candidatos = paramsCandidatos === 'false' ? false : true;
  /* data*/
  const [info, setInfo] = useState([]);
  const [seeMore, setSeeMore] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [votes, setVotes] = useState({
    votesAnnulled: 0,
    votesBlank: 0,
    votesInvalid: 0,
  });
  /* set data */
  groupBy.shim();
  const numberFormat = (number) => number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  const formatedJSONData = (data) =>
    data?.map((e) => ({
      ...e,
      color: e?.settings?.color || '#000000',
      votes: numberFormat(e?.votes || 0.0),
      votes_percent: parseFloat(e?.votes_percent || 0.0),
      candidates: e.candidates.sort(function (a, b) {
        if (a.candidate_id > b.candidate_id) return 1;
        if (a.candidate_id < b.candidate_id) return -1;
        return 0;
      }),
    }));
  const getData = async () => {
    try {
      // currentData.parties.length = 1;
      let missingParties = currentData?.parties || [];
      if (missingParties?.length < JSONState[currentState]?.parties?.length) {
        // agrega cards de partidos faltantes
        missingParties = JSONState[currentState].parties.map((party) => {
          if (missingParties.find((p) => p.party_id === party.party_id)) {
            return missingParties.find((p) => p.party_id === party.party_id);
          }
          return party;
        });

        // vuelve a ordenar por mayor numero de votos
        missingParties = missingParties.sort(function (a, b) {
          if (a.votes < b.votes) return 1;
          if (a.votes > b.votes) return -1;
          return 0;
        });
      }
      let formatedData = formatedJSONData(missingParties);

      setInfo(formatedData);
      setVotes({
        votesTotal: numberFormat(currentData?.election?.total_votes?.qty || 0.0),
        votesAnnulled: numberFormat(currentData?.stats?.find((e) => e.type === 'annulled').votes || 0.0),
        votesBlank: numberFormat(currentData?.stats?.find((e) => e.type === 'blank').votes || 0.0),
        votesInvalid: currentData?.election?.tables?.percent?.toFixed(2).toString() || 0.0,
      });
    } catch (error) {
      let formatedDataError = formatedJSONData(JSONState[currentState]?.parties);
      setInfo(formatedDataError);
      console.log(error);
    }
  };

  /* functions */
  const styleHeightCard = () => {
    let rows = 0;
    if (seeMore) {
      if (isDesktop) {
        rows = Math.ceil(info.length / 3);
        return `${287 * rows + 17 * rows}px`;
      }
      if (isTablet) {
        rows = Math.ceil(info.length / 2);
        return `${282 * rows + 25 * rows}px`;
      }
      if (isMobile) {
        return `${307 * info.length + 120}px`;
      }
      return `${396 * info.length + 20}px`;
    } else {
      return;
    }
  };
  /* resize */
  useDimension(setIsMobile, 300);
  useDimension(setIsTablet, 650);
  useDimension(setIsDesktop, 1100);
  let getSize = info.length > (isDesktop ? 3 : isTablet ? 2 : 1);

  const showMoreBtn = () => (
    <div
        onClick={() => setSeeMore(!seeMore)}
        className={`g-container__button ${getSize && !seeMore ? 'g-container__button-shadow' : ''}`}
      >
        {getSize && seeMore && <div className="arrow" style={{ transform: 'rotate(180deg)' }}></div>}
        {getSize && <button>{seeMore ? 'MOSTRAR MENOS' : 'MOSTRAR MÁS'}</button>}
        {getSize && !seeMore && <div className="arrow"></div>}
      </div>
  );

  const setShowMore = () => { 
    if (limitLenght && !isDesktop) {
      if (limit > 2 ) {
        return showMoreBtn();
      } 
      return null
    }

    if (limitLenght && isDesktop) {
      if (limit > 3 ) {
        return showMoreBtn();
      } 
      return null
    }

    if (!limitLenght) {
      return showMoreBtn();
    }

    return null
  };  

  const card = (coal) => (
    <div 
      key={coal.party_id} 
      className={`g-container__card${(isDesktop && info.length <= 2) || (isDesktop && limitLenght && limit <= 2) ? '-short' : ''}`}>
      <PresiCard party={coal} isMobile={isMobile} showVotes={showVotes} formatNumber={formatNumber} limit={limit}/>
    </div>
  );

  const setShowCard = (info) => {
    if (limitLenght) {
      return info.map((coal, index) => (
        index <= limit - 1
        ?
          card(coal)
        : 
          null
      ))
    }

    if (!limitLenght) {
      return info.map((coal) => (
        card(coal)
      ))
    }

    return null
  };

  useEffect(() => {
    getData();
  }, []);
  
  return (
    <>
      {candidatos && (
        <>
          <div
            className={`g-container__cards ${!seeMore ? 'g-container__cards-in' : 'g-container__cards-out'}`}
            style={{ maxHeight: styleHeightCard() }}
          >
            {setShowCard(info)}
          </div>
          {setShowMore()}
        </>
      )}
      {elecciones ? (showResume && <PresiResume votes={votes} country={country} theme={theme} shortVersion={shortVersion} formatNumber={formatNumber} />) : ''}
    </>
  );
};
export default ListCandidates;
